<div class="user-container">
  @if (imageBackgroundStyle) {
  <div
    class="user-picture image"
    [style.height]="size?.height"
    [style.width]="size?.width"
    [style.background-color]="backgroundColor"
    [style.background-image]="imageBackgroundStyle"
  ></div>
  } @if (!imageBackgroundStyle) {
  <div
    class="user-picture initials"
    [style.background-color]="color"
    [style.height]="size?.height"
    [style.width]="size?.width"
  >
    @if (showInitials) {
    <p>{{ initials }}</p>
    } @if (!showInitials) {
    <p>{{ firstNameFirstLetter }}</p>
    }
  </div>
  } @if (!pictureOnly) {
  <div class="info-container">
    @if (showName && username) {
    <p class="user-name">{{ username }}</p>
    } @if (showTitle && title) {
    <p class="user-title">{{ title }}</p>
    }
  </div>
  }
</div>
